import './bonurawest/style';
import FormStructure from './bonurawest/form_structure';

export default FormStructure;